import { render, staticRenderFns } from "./warehouseRecord.vue?vue&type=template&id=3146e992&scoped=true&"
import script from "./warehouseRecord.vue?vue&type=script&lang=js&"
export * from "./warehouseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146e992",
  null
  
)

export default component.exports